/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryinfosize3Inputs */

const en_medialibraryinfosize3 = /** @type {(inputs: Medialibraryinfosize3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File size`)
};

const de_medialibraryinfosize3 = /** @type {(inputs: Medialibraryinfosize3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateigröße`)
};

/**
* | output |
* | --- |
* | "File size" |
*
* @param {Medialibraryinfosize3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryinfosize3 = /** @type {((inputs?: Medialibraryinfosize3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryinfosize3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryinfosize3(inputs)
	return de_medialibraryinfosize3(inputs)
});
export { medialibraryinfosize3 as "mediaLibraryInfoSize" }